import axios from 'axios';
import { BASE_URL } from './api';

// Everything the response poll recorded against sent outreach, newest first
// (dev-only feed). Not replies only -- rows carry a `kind` of 'reply', 'bounce'
// (a delivery-failure notice) or 'outbound' (a reply composed in Outlook rather
// than through the app), so treating the feed as "who responded" means passing
// kind: ['reply'].
// Optional filters: { client[], campaign[], email_template[], sent_by[], kind[],
// received_after, received_before, search, page }. Array filters are serialized
// as repeated params (client=1&client=2) for the DRF ModelMultipleChoiceFilter
// backend, matching the outreach-messages endpoint.
export async function getOutreachResponses(token, params = {}) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/outreach-responses/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        params: params,
        paramsSerializer: (rawParams) => {
            const sp = new URLSearchParams()
            Object.entries(rawParams).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((item) => sp.append(key, item))
                } else if (value !== undefined && value !== null && value !== '') {
                    sp.append(key, value)
                }
            })
            return sp.toString()
        }
    }).then((response) => {
        return {
            results: response.data.results,
            count: response.data.count,
            next: response.data.next,
            prev: response.data.previous,
            page: response.data.page,
            pageSize: response.data.page_size,
            numPages: response.data.num_pages,
        };
    }).catch((error) => {
        throw error
    });
}
